import Sider from "../../comps/sider/main";
import React, { useState } from "react";
import { Tag, Button, Modal, Input, Form, Tabs, ColorPicker, Select, Segmented, Radio, Divider, DatePicker } from "antd";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { BarsOutlined, SettingOutlined, HolderOutlined, PictureOutlined, ThunderboltOutlined, PicCenterOutlined, CalendarOutlined, DeleteOutlined, SmallDashOutlined, InboxOutlined, } from '@ant-design/icons';
import './main.css'
import FontPicker from "font-picker-react";
import dayjs from 'dayjs';
function LinkExtract() {
    const [links, setLinks] = useState([
        { id: "1", url: "https://instagram.com/dailymahiti_", title: "Instagram", description: "" },
        { id: "2", url: "https://www.youtube.com/@dailymahiti", title: "YouTube", description: "" },
        { id: "3", url: "https://www.facebook.com/dailymahiti", title: "Facebook", description: "" },
        { id: "4", url: "https://www.filmyzilla.vg", title: "Filmyzilla", description: "Movies Website" },
        { id: "5", url: "http://services.india.gov.in", title: "Govt Services", description: "National Portal" },
    ]);


    const DEFAULT_COLOR = [
        {
            color: 'rgb(16, 142, 233)',
            percent: 0,
        },
        {
            color: 'rgb(135, 208, 104)',
            percent: 100,
        },
    ];

    let gfAPI = "AIzaSyBvWOlG-yMweh3-iKbA7L5u8mPzzkABLjE"

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [newLink, setNewLink] = useState({ title: "", url: "", description: "" });

    // Show Add Link Modal
    const showModal = () => {
        setIsModalOpen(true);
    };

    const colorChange = (color) => {
        setCustomTheme({ customTheme, button_color: color.toCssString() })
    }

    const [customTheme, setCustomTheme] = useState({
        "button_theme": "fill-btn",
        "button_color": "#ffffff",
        "button_text_color": "#000000",
        "shadow_color": "#000000",
        "font": "Poppins",
        "text_color": "#000000",
        "background": "color",
        "background_color": "#ffffff",
        "gradient_direction": "up",
        "background_media": "",
        "background_blur": ""

    })

    const onDragEnd = (result) => {
        if (!result.destination) return;

        const { source, destination } = result;
        const newLinks = [...links];
        const [removed] = newLinks.splice(source.index, 1);

        newLinks.splice(destination.index, 0, removed);

        setLinks(newLinks);
    };
    const LinksList = () => {
        return <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="links">
                {(provided) => (
                    <div
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                    >
                        {links.map((link, index) => (
                            <Draggable key={link.id} draggableId={link.id} index={index}>
                                {(provided) => (
                                    <div
                                        className="link-card"
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        style={{

                                            ...provided.draggableProps.style,
                                        }}
                                    >
                                        <div
                                            className="link-card-core"
                                        >
                                            <HolderOutlined {...provided.dragHandleProps}
                                                style={{
                                                    padding: "10px",
                                                    borderRadius: "5px",
                                                    fontSize: '20px',
                                                    fontWeight: 'bold',
                                                    cursor: "move",
                                                    opacity: '.6'
                                                }} />

                                            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>

                                                <div>
                                                    <p><strong>{link.title}</strong></p>
                                                    <p>{link.url}</p>
                                                    <p>{link.description}</p>
                                                </div>
                                                <Tabs

                                                    items={
                                                        [
                                                            {
                                                                key: 0,

                                                                children: ``,
                                                                icon: <SmallDashOutlined />,
                                                            },
                                                            {
                                                                key: 1,

                                                                children: <div className="">
                                                                    <p className="expand-title">Thumbnil & Layout</p>
                                                                    <div>
                                                                        <p>Thumbnil goes here</p>
                                                                        <div>
                                                                            <div>Change the Thumbnil</div>
                                                                            <div>Remove the Thumbnil</div>
                                                                        </div>
                                                                    </div>
                                                                    <div>
                                                                        <div>

                                                                        </div>
                                                                        <div>Featured Layout </div>
                                                                    </div>
                                                                </div>,
                                                                icon: <PictureOutlined className="icon" />,
                                                            },
                                                            {
                                                                key: 2,

                                                                children: <div>
                                                                    <p className="expand-title">Prioritize</p>
                                                                    <div className="animation-details">
                                                                        <p>Choose the animation style</p>
                                                                        <div className="row">
                                                                            <p className="animate-demo buzz">Buzz</p>
                                                                            <p className="animate-demo wobble">Wobble</p>
                                                                            <p className="animate-demo pop">Pop</p>
                                                                        </div>
                                                                    </div>

                                                                </div>,
                                                                icon: <ThunderboltOutlined className="icon" />,
                                                            },
                                                            {
                                                                key: 3,

                                                                children: <div>
                                                                    <p className="expand-title">Sechduled</p>
                                                                    <p>Show link on</p>
                                                                    <DatePicker
                                                                        format="YYYY-MM-DD HH:mm:ss"
                                                                        showTime={{
                                                                            defaultValue: dayjs('00:00:00', 'HH:mm:ss'),
                                                                        }}
                                                                        onChange={(date, dateString) => {
                                                                            console.log(dateString);
                                                                        }}
                                                                    />
                                                                    <p>Hide link on</p>
                                                                    <DatePicker
                                                                        format="YYYY-MM-DD HH:mm:ss"
                                                                        onChange={(date, dateString) => {
                                                                            console.log(date, dateString);
                                                                        }}
                                                                        showTime={{
                                                                            defaultValue: dayjs('00:00:00', 'HH:mm:ss'),

                                                                        }}
                                                                    />
                                                                </div>,
                                                                icon: <CalendarOutlined className="icon" />,
                                                            },
                                                            {
                                                                key: 4,

                                                                children: <div>
                                                                    <p className="expand-title">Archive or Delete</p>
                                                                    <div className="row" style={{ gap: '20px' }}>

                                                                        <Button color="danger" variant="solid" icon={<DeleteOutlined />}>Delete the link</Button>
                                                                        <Button color="danger" variant="outlined" icon={<InboxOutlined />}>Archive the Link</Button>
                                                                    </div>
                                                                </div>,
                                                                icon: <DeleteOutlined className="icon" />,
                                                            }
                                                        ]
                                                    }
                                                />
                                                {/* <div className="link-icons">
                                                        <PictureOutlined className="icon"/>
                                                        <ThunderboltOutlined className="icon"/>
                                                        <CalendarOutlined className="icon"/>
                                                        <DeleteOutlined className="icon"/>
                                                    </div> */}
                                                <div>

                                                </div>
                                            </div>



                                        </div>
                                    </div>
                                )}
                            </Draggable>
                        ))}
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>
        </DragDropContext>
    }


    const Settings = () => {

        const buttonTypes = [
            {
                title: 'Fill',
                className: 'fill-btn',
                types: [
                    { className: '' },
                    { className: 'border-lite' },
                    { className: 'border-max' },
                ],
            },
            {
                title: 'Outline',
                className: 'outline-btn',
                types: [
                    { className: '' },
                    { className: 'border-lite' },
                    { className: 'border-max' },
                ],
            },
            {
                title: 'Soft Shadow',
                className: 'outline-btn soft-shadow',
                types: [
                    { className: '' },
                    { className: 'border-lite' },
                    { className: 'border-max' },
                ],
            },
            {
                title: 'Hard Shadow',
                className: 'outline-btn hard-shadow',
                types: [
                    { className: '' },
                    { className: 'border-lite' },
                    { className: 'border-max' },
                ],
            },
        ];


        return <div className="themes setting-lib">

            <h1>Themes</h1>
            <div className="white-bg">

                <div className="row">
                    <div className="theme-card"></div>
                    <div className="theme-card"></div>
                    <div className="theme-card"></div>
                    <div className="theme-card"></div>
                    <div className="theme-card"></div>
                    <div className="theme-card"></div>
                </div>
            </div>

            <h1>Custom Themes</h1>
            <h1>Background</h1>
            <div className="white-bg">


                <div className="row">
                    <div className="theme-card">Color</div>
                    <div className="theme-card">Image/GIF</div>
                </div>
                <div>
                    <h1>Background Color</h1>
                    <ColorPicker
                        allowClear
                        mode={['single', 'gradient']}
                        showText
                        onChangeComplete={(color) => {
                            // console.log(color.toCssString());
                        }}

                    />
                </div>
                <div>
                    <h1>Gradient Direction</h1>
                    <Radio.Group

                        defaultValue={customTheme.gradient_direction}
                        onChange={(e) => setCustomTheme({ ...customTheme, gradient_direction: e.target.value })}

                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 8,
                        }}

                        options={[
                            {
                                value: 'up',
                                label: <div className="flex-segment"><div className="gradient-up" /> Up</div>,
                            },
                            {
                                value: 'down',
                                label: <div className="flex-segment"><div className="gradient-down" /> Down </div>,
                            },

                        ]}
                    />

                </div>

                <div>
                    <h1>Image / GIF </h1>
                    <p>File upload</p>
                </div>
            </div>


            <h1>Buttons</h1>
            <div className="white-bg">

                <div>
                    {buttonTypes.map((buttonType, index) => (
                        <div key={index}>
                            <p>{buttonType.title}</p>
                            <div className="row">
                                {buttonType.types.map((shadow, shadowIndex) => (
                                    <div
                                        onClick={() => {
                                            setCustomTheme({ ...customTheme, "button_theme": `${buttonType.className} ${shadow.className}` })
                                        }}
                                        key={shadowIndex}
                                        className={customTheme.button_theme == `${buttonType.className} ${shadow.className}` ? `${buttonType.className} ${shadow.className} select-option selected-option` : `${buttonType.className} ${shadow.className} select-option`}
                                    />
                                ))}
                            </div>
                        </div>
                    ))}
                </div>

                <div>
                    <h4>Button Color</h4>
                    <ColorPicker
                        mode={['single', 'gradient']}
                    // showText
                    // defaultValue ={`${customTheme.button_color}`}
                    // onChangeComplete={(color) => {
                    //     setCustomTheme((prevState) => ({
                    //     ...prevState,
                    //     button_color: color.toCssString(),
                    //     }));
                    // }}
                    />


                    <h4>Button Text Color</h4>
                    <ColorPicker
                        allowClear
                        showText
                        mode={['single', 'gradient']}
                        defaultValue={customTheme.button_text_color}
                        onChangeComplete={(color) => {
                            setCustomTheme({ customTheme, button_text_color: color.toCssString() })
                            // console.log(color.toCssString());
                        }}

                    />

                    <h4>Button Shadow color</h4>
                    <ColorPicker
                        allowClear
                        showText
                        mode={['single', 'gradient']}
                        defaultValue={customTheme.shadow_color}
                        onChangeComplete={(color) => {
                            setCustomTheme({ customTheme, shadow_color: color.toCssString() })

                        }}

                    />


                    <h4>Font</h4>
                    <FontPicker

                        apiKey={gfAPI}
                        activeFontFamily={customTheme.font}
                        onChange={(nextFont) => {
                            console.log("nextFont.family", nextFont.family)
                            setCustomTheme({ ...customTheme, font: nextFont.family })
                        }
                        }
                    />

                    <h4>Text Color</h4>
                    <ColorPicker
                        showText
                        allowClear
                        defaultValue={customTheme.text_color}
                        mode={['single', 'gradient']}
                        onChangeComplete={(color) => {
                            setCustomTheme(prevState => ({ ...prevState, text_color: color.toCssString() }))
                        }}

                    />

                </div>
            </div>

            <div>
                <p>InstatnDM Logo removal</p>
            </div>

            <div>
                <p>SEO Settings</p>
            </div>


        </div>
    }
    return (
        <div className="page-layout link-in-bio">
            <Sider />
            <div className="page-content">
                <div className="desktop row" style={{ padding: "20px" }}>
                    <div className="page-title">
                        <h1>
                            Link In BIO
                            <Tag color="purple" style={{ marginLeft: "10px", fontSize: "14px", fontWeight: "normal" }}>
                                New
                            </Tag>
                        </h1>
                        <p>Manage your links in a single platform, create your link in bio.</p>
                    </div>

                    {/* Add Link Button */}
                    <Button type="primary" onClick={showModal} style={{ marginBottom: "20px" }}>
                        Add New Link
                    </Button>
                </div>

                <Tabs
                    // onChange={onChange}
                    type="card"
                    items={[{
                        label: <p><PicCenterOutlined /> Links</p>,
                        key: "links",
                        children: <LinksList />,
                    },
                    {
                        label: <p>{<SettingOutlined />} Settings</p>,
                        key: "settings",
                        children: <Settings />,
                    },]}
                />

            </div>
        </div>
    );
}

export default LinkExtract;
